import { makeStyles } from '@material-ui/core/styles';


export const PanelUserDetailStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  card: {
    padding: theme.spacing(3),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: '80px',
    marginTop: '-1%',
    marginBottom: '2%',
    width:'114%'
},
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 190,
  },
  TableCell: {
    color: '#0088FE',
    fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
    fontWeight: 'bold',
    fontSize: '17px',
    borderRadius:'10px'

  }, paper1: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    width: '100%',
    marginTop: '2%'
  },

}));